export const adjectives = [
  'glorious',
  'righteous',
  'valiant',
  'relentless',
  'unyielding',
  'merciless',
  'indomitable',
  'unbreakable',
  'fearless',
  'dauntless',
  'unwavering',
  'steadfast',
  'noble',
  'devoted',
  'supreme',
  'ironclad',
  'resolute',
  'vigilant',
  'heroic',
  'stalwart',
  'unshaken',
  'disciplined',
  'obedient',
  'triumphant',
  'indestructible',
  'honorable',
  'mighty',
  'formidable',
  'dominant',
  'unyielding',
  'ruthless',
  'tenacious',
  'loyal',
  'gallant',
  'fearsome',
  'epic',
  'invincible',
  'thunderous',
  'unrelenting',
  'colossal',
  'unassailable',
  'sovereign',
  'titanic',
  'unforgiving',
  'resplendent',
  'ferocious',
  'undeniable',
  'commanding',
  'unstoppable',
  'steadfast',
  'undaunted',
  'indomitable',
  'glimmering',
  'unyielding',
  'rampant',
  'defiant',
  'unbowed',
  'impervious',
  'sacred',
  'divine',
  'eternal',
  'peerless',
  'magnificent',
  'absolute',
  'resurgent',
  'crushing',
  'furious',
  'imposing',
  'undying',
  'adamant',
  'invulnerable',
  'fearsome',
  'supreme',
  'unerring',
  'immovable',
  'unshakable',
  'tactical',
  'peerless',
  'unstained',
  'revered',
  'untouchable',
  'warborn',
  'selfless',
  'unyielding',
  'imperial',
  'legendary',
  'unquestionable',
  'steadfast',
  'hardened',
  'valorous',
  'eternal',
  'righteous',
  'reckoning',
  'thunderous',
  'immortal',
  'unrelenting',
  'tactical',
  'mighty',
  'commanding',
  'unswerving',
  'infallible',
  'irrefutable',
  'audacious',
  'courageous',
  'indefatigable',
  'implacable',
  'intrepid',
  'unflinching',
  'inexorable',
  'adamantine',
  'redoubtable',
  'inviolable',
  'ironwilled',
  'battlehardened',
  'steelhearted',
  'lionhearted',
  'undauntable',
  'remorseless',
  'pitiless',
  'grim',
  'unbending',
  'steelclad',
  'battleready',
  'razoredged',
  'inexhaustible',
  'overmastering',
  'conquering',
  'victorious',
  'unvanquished',
  'impregnable',
  'martial',
  'militant',
  'strategic',
  'surgical',
  'precise',
  'lightning',
  'ironbound',
  'warlike',
  'hawkeyed',
  'eagleeyed',
  'watchful',
  'tireless',
  'boundless',
  'raging',
  'blazing',
  'thundering',
  'roaring',
  'unmerciful',
  'decisive',
  'unhesitating',
  'brave',
  'bold',
  'daring',
  'potent',
  'exalted',
  'august',
  'crowned',
  'crimson',
  'obsidian',
  'granite',
  'ironshod',
  'battleborn',
  'battlescarred',
  'bloodforged',
  'oathbound',
  'everwatchful',
  'evervigilant',
  'eversteady',
  'coldforged',
  'firetempered',
  'winterhardened',
  'sunforged',
  'shadowforged',
  'stormhardened',
  'flametempered',
  'sturdy',
  'robust',
  'staunch',
  'hardy',
  'ironhearted',
  'battlewise',
  'warseasoned',
  'seasoned',
  'battletested',
  'irontempered',
  'stonefaced',
  'grimfaced',
  'stormcharged',
  'frostforged',
  'emberforged',
  'earthshaking',
  'skyshaking',
  'groundshaking',
  'shadowclad',
  'emberclad',
  'ironclad',
  'steelblooded',
  'ironblooded',
  'strongwilled',
  'battlepurposed',
  'warforged',
  'stormborn',
]

export const nouns = [
  'liberator',
  'justice',
  'vengeance',
  'patriot',
  'sentinel',
  'champion',
  'executor',
  'crusader',
  'conqueror',
  'purifier',
  'judgment',
  'protector',
  'avenger',
  'defender',
  'watchman',
  'warrior',
  'guardian',
  'savior',
  'bastion',
  'shield',
  'hammer',
  'legion',
  'banner',
  'spear',
  'dominator',
  'supremacy',
  'annihilator',
  'battlemaster',
  'herald',
  'oathkeeper',
  'discipline',
  'martyr',
  'beacon',
  'sentinel',
  'overlord',
  'bulwark',
  'vindicator',
  'preserver',
  'justice',
  'authority',
  'saber',
  'retribution',
  'storm',
  'flagship',
  'glory',
  'indignation',
  'retaliation',
  'sovereignty',
  'pinnacle',
  'wrath',
  'renegade',
  'fortress',
  'dominion',
  'valor',
  'virtue',
  'triumph',
  'arbiter',
  'enforcer',
  'warden',
  'paladin',
  'templar',
  'lancer',
  'striker',
  'vanguard',
  'vanquisher',
  'reaper',
  'harbinger',
  'archon',
  'praetorian',
  'centurion',
  'legatus',
  'tribune',
  'colossus',
  'titan',
  'leviathan',
  'phoenix',
  'dragon',
  'hydra',
  'goliath',
  'behemoth',
  'juggernaut',
  'warhammer',
  'warblade',
  'greatsword',
  'halberd',
  'glaive',
  'pike',
  'scythe',
  'maul',
  'mace',
  'gauntlet',
  'rampart',
  'citadel',
  'keep',
  'stronghold',
  'redoubt',
  'phalanx',
  'cohort',
  'legionary',
  'standard',
  'banneret',
  'paragon',
  'avatar',
  'warlord',
  'warmaster',
  'battlelord',
  'highguard',
  'skyguard',
  'stormguard',
  'shieldbearer',
  'swordbearer',
  'standardbearer',
  'pathfinder',
  'forerunner',
  'trailblazer',
  'outrider',
  'scout',
  'ranger',
  'marksman',
  'sniper',
  'artillerist',
  'rocketeer',
  'grenadier',
  'sapper',
  'saboteur',
  'breacher',
  'breaker',
  'crusher',
  'blitzer',
  'stormbringer',
  'earthshaker',
  'icebreaker',
  'firespear',
  'thunderbolt',
  'thunderhead',
  'stormcaller',
  'spellbreaker',
  'headhunter',
  'gatekeeper',
  'watcher',
  'lookout',
  'overseer',
  'commander',
  'captain',
  'marshal',
  'general',
  'admiral',
  'prefect',
  'proconsul',
  'consul',
  'chieftain',
  'warchief',
  'kingmaker',
  'executioner',
  'punisher',
  'subjugator',
]
